import { Box, Stack, Text } from '@ltvco/refresh-lib/theme';

import { constants } from 'appConstants';

const statusPalette = {
  blocked: {
    bg: 'error.light',
    borderColor: 'error.main',
    label: 'error.main',
    title: 'error.dark',
    body: 'error.dark',
    ref: 'error.main',
    iconColor: 'error.main',
  },
  clean: {
    bg: 'success.light',
    borderColor: 'success.main',
    label: 'success.dark',
    title: 'success.dark',
    body: 'text.secondary',
    ref: 'success.main',
    iconColor: 'success.main',
  },
} as const;

export default function GSMADeviceStatus({
  blocklistStatus = 'no',
  refCode = '',
}) {
  const isBlocked = blocklistStatus.toLowerCase() === 'yes';
  const palette = isBlocked ? statusPalette.blocked : statusPalette.clean;
  const { images } = constants;

  return (
    <Box
      sx={{
        backgroundColor: palette.bg,
        border: 1,
        borderColor: palette.borderColor,
        borderRadius: 2.5,
        px: { xs: 2.5, sm: 4 },
        py: 3,
        maxWidth: 800,
        width: '100%',
      }}
    >
      <Stack direction="row" spacing={2.5} alignItems="center">
        {/* Icon */}
        <Box sx={{ flexShrink: 0 }}>
          {isBlocked ? (
            <img src={images.imgShieldBlockIcon} alt="Shield Block Icon" />
          ) : (
            <img src={images.imgShieldCheckIcon} alt="Shield Check Icon" />
          )}
        </Box>

        <Box>
          <Text
            variant="overline"
            color={palette.label}
            sx={{
              fontWeight: 700,
              fontSize: '0.65rem',
              letterSpacing: '0.12em',
              display: 'block',
              mb: 0.3,
            }}
          >
            GSMA DEVICE REGISTRY
          </Text>

          <Text
            variant="h6"
            color={palette.title}
            sx={{
              fontWeight: 700,
              fontSize: { xs: '1.15rem', sm: '1.35rem' },
              lineHeight: 1.2,
              mb: 0.6,
            }}
          >
            {isBlocked
              ? 'Blocked — listed on the GSMA block list'
              : 'Clean - not on any GSMA list'}
          </Text>

          <Text
            variant="body2"
            color={palette.body}
            sx={{
              fontSize: '0.875rem',
              lineHeight: 1.5,
              mb: refCode ? 1 : 0,
            }}
          >
            {isBlocked
              ? 'This IMEI is flagged on the GSMA Block List. The device should not be activated, sold, or bought.'
              : 'This IMEI is not flagged on the GSMA Block List or General List. The device is clear to activate, sell, or buy.'}
          </Text>

          {refCode && (
            <Text variant="caption" color={palette.ref}>
              Reference: {refCode}
            </Text>
          )}
        </Box>
      </Stack>
    </Box>
  );
}
